import { CalendarEventTitleFormatter } from 'angular-calendar';

export class SchedulerEventTitleFormatter extends CalendarEventTitleFormatter {

}
